import AppBar from "./components/AppBar.jsx/AppBar";

const MainLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <AppBar />
      <div className="dark-text">{children}</div>
    </div>
  );
};

export default MainLayout;
